// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1mRWe","left":"InfoRow_left__1aB27"};